<template>
  <Modal v-model="editMailboxsModal" :title="$t('configuration_management.mailbox_management.editEmail')" @on-ok="mailboxsSubmit('mailboxsEditForm')"
         @on-cancel="mailboxsReset('mailboxsEditForm')" :loading="loading" :mask-closable="false"
         :on-open-modal="editMailboxsModal=true" :okText="$t('common.edit')" :cancelText="$t('alarms.common.cancel')">
    <Form ref="mailboxsEditForm" :model="mailboxsEditForm" :label-width="100" :rules="ruleValidate">
      <!-- 邮箱名称 -->
      <FormItem :label="$t('configuration_management.mailbox_management.emailName')" prop="name">
        <Input v-model="mailboxsEditForm.name" placeholder="Enter something..." style="width:300px;"></Input>
      </FormItem>

      <!-- 主机地址 -->
      <FormItem :label="$t('configuration_management.mailbox_management.host')" prop="host">
        <Input v-model="mailboxsEditForm.host" placeholder="Enter something..." style="width:300px;"></Input>
      </FormItem>

      <!-- 端口 -->
      <FormItem :label="$t('configuration_management.mailbox_management.port')" prop="port">
        <Input type="number" v-model="mailboxsEditForm.port" style="width:300px;"></Input>
      </FormItem>

      <!-- 用户名 -->
      <FormItem :label="$t('configuration_management.mailbox_management.userName')" prop="userName">
        <Input v-model="mailboxsEditForm.userName" style="width:300px;"></Input>
      </FormItem>

      <!-- 密码 -->
      <FormItem :label="$t('configuration_management.mailbox_management.password')" prop="password">
        <Input type="password" v-model="mailboxsEditForm.password" style="width:300px;"></Input>
      </FormItem>

      <!-- 描述 -->
      <FormItem :label="$t('configuration_management.mailbox_management.describe')" prop="describe">
        <Input v-model="mailboxsEditForm.describe" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
               placeholder="Enter something..." style="width:300px;"></Input>
      </FormItem>

    </Form>
  </Modal>
</template>
<script>
  export default {
    name: 'EditMailboxs',
    props: ['mailboxsEditOldForm'],
    data() {
      return {
        mailboxsEditForm: {
          id: '',
          name: '',
          host: '',
          port: '',
          userName: '',
          password: '',
          describe: ''
        },
        editMailboxsModal: false,
        loading: true,
        ruleValidate: {
          name: [
            {required: true, message: this.$t('configuration_management.mailbox_management.emailNameRequired'), trigger: 'change'}
          ],
          port: [
            {required: true, message: this.$t('configuration_management.mailbox_management.portRequired')}
          ],
          host: [
            {required: true, message: this.$t('configuration_management.mailbox_management.hostRequired'), trigger: 'change'}
          ],
          userName: [
            {required: true, message: this.$t('configuration_management.mailbox_management.userNameRequired'), trigger: 'change'}
          ],
          password: [
            {required: true, message: this.$t('configuration_management.mailbox_management.passwordRequired'), trigger: 'change'}
          ],
          describe: [
            {required: false, message: this.$t('configuration_management.mailbox_management.pleaseEnterDescribe'), trigger: 'change'},
            {type: 'string', max: 100, message: this.$t('configuration_management.common.max100Characters'), trigger: 'change'}
          ]
        }
      }
    },
    mounted: function () {
      this.mailboxsShow();
    },
    methods: {
      mailboxsShow: function () {
        this.$api.mailbox.select("id", this.mailboxsEditOldForm.id)
          .then(res => {
            this.mailboxsEditForm.id = res.data.id;
            this.mailboxsEditForm.name = res.data.name;
            this.mailboxsEditForm.host = res.data.host;
            this.mailboxsEditForm.port = res.data.port;
            this.mailboxsEditForm.userName = res.data.userName;
            this.mailboxsEditForm.password = res.data.password;
            this.mailboxsEditForm.describe = res.data.description;
          })
      },
      mailboxsSubmit: function (name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            // 编辑日程
            this.$api.mailbox.update({
              "id": this.mailboxsEditForm.id,
              "name": this.mailboxsEditForm.name,
              "host": this.mailboxsEditForm.host,
              "port": this.mailboxsEditForm.port,
              "userName": this.mailboxsEditForm.userName,
              "password": this.mailboxsEditForm.password,
              "description": this.mailboxsEditForm.describe
            })
              .then(res => {
                this.data = res.data;
                setTimeout(() => {
                  // 子组件引用父组件methods里面的方法
                  this.$parent.showAll();
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t('common.addSuccess'));
                  this.$emit("on-close-cancel", false);
                  this.editMailboxsModal = false;
                }, 1000);
              })
          } else {
            //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            this.$Message.error(this.$t('common.addFail'));
          }
        });
      },
      mailboxsReset: function (name) {
        this.$emit("on-close-cancel", false);
        this.$refs[name].resetFields();
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/monitor_mailbox_configuration/EditMailboxs.vue